import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  manualHeaderText: {
    borderRadius: 1,
    width: "20ch",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    ":hover": {
      backgroundColor: "grey.800",
      cursor: "pointer",
    },
  },
  manualHeaderIcon: {
    objectFit: "contain",
    width: "1.5rem",
    height: "1.5rem",
  },
  manualContainer: {
    position: "absolute",
    inset: 0,
    zIndex: 110,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "brightness(0.8) blur(15px)",
    overflowY: "scroll",
    cursor: "help",
  },
};
